import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { borrowingBaseEnabledGuardFn } from '@core/guards/borrowing-base-enabled/borrowing-base-enabled.guard';
import {
  inspectorPortalGuardFn,
  redirectInspectorsGuardFn,
} from '@core/guards/inspector-portal/inspector-portal.guard';
import { EmailCallbackPage } from '@v2/modules/email-app/pages/email-callback/email-callback.page';
import { BBReportsComponent } from './borrowing-base/bb-reports/bb-reports.component';
import { BorrowingBaseMainComponent } from './borrowing-base/borrowing-base-main.component';
import { BorrowingBaseComponent } from './borrowing-base/view/borrowing-base.component';
import { authGuardFn } from './core/authentication/auth.guard';
import { LoginComponent } from './login/login.component';
import { PlaidLinkComponentComponent } from './plaid-link-component/plaid-link-component.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SmsMessagingComponent } from './sms-messaging/sms-messaging.component';

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  bindToComponentInputs: true,
};

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [redirectInspectorsGuardFn, authGuardFn],
  },
  {
    path: '',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    canActivate: [redirectInspectorsGuardFn, authGuardFn],
  },
  {
    path: 'borrowing-base',
    component: BorrowingBaseMainComponent,
    canActivate: [redirectInspectorsGuardFn, authGuardFn, borrowingBaseEnabledGuardFn],
    children: [
      {
        path: '',
        component: BorrowingBaseComponent,
      },
      {
        path: 'reports',
        component: BBReportsComponent,
      },
    ],
  },
  {
    path: 'sms-messaging',
    component: SmsMessagingComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'plaid',
    component: PlaidLinkComponentComponent,
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
  },
  { path: 'email/oauth/gmail/callback', component: EmailCallbackPage },
  { path: 'email/oauth/outlook/callback', component: EmailCallbackPage },
  { path: 'oauth/gmail/callback', component: EmailCallbackPage },
  { path: 'oauth/outlook/callback', component: EmailCallbackPage },
  { path: 'oauth/callback', component: EmailCallbackPage },
  {
    path: 'v2',
    loadChildren: () => import('./v2/v2.module').then(m => m.V2Module),
    canActivate: [redirectInspectorsGuardFn],
    //canActivate: [authGuardFn]
  },
  {
    path: 'borrower-portal',
    loadChildren: () => import('./v2/borrower-portal').then(m => m.BorrowerPortalModule),
  },
  {
    path: 'inspector-portal',
    loadChildren: () => import('./v2/inspector-portal').then(m => m.InspectorPortalModule),
    canActivate: [inspectorPortalGuardFn],
  },
  // {
  //   path: '',
  //   redirectTo: '',
  //   pathMatch: 'full',
  //   canActivate: [authGuardFn]
  // },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
